import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { Slot } from '../../../Modules/Slot/Model/Slot';
import { useAppSelector } from '../../../Modules/Presentation/hooks';
import { selectAccounts } from '../../../Modules/Account/Presentation/selectors';

const { Option } = Select;

interface Props {
  open: boolean;
  slotCount: number;
  onClose: () => void;
  onSubmit: (dto: Partial<Slot>) => void;
}

const SlotBulkEditModal: React.FC<Props> = ({
  open,
  slotCount,
  onClose,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  /* 셀러 목록 */
  const accounts = useAppSelector(selectAccounts);
  const sellers = accounts
    .filter(a => a.grade === 'SELLER')
    .sort((a, b) => a.username.localeCompare(b.username));

  return (
    <Modal
      open={open}
      title={`선택된 ${slotCount}개 슬롯 일괄 수정`}
      okText="저장"
      onCancel={onClose}
      onOk={() =>
        form.validateFields().then(values => {
          const dto = Object.fromEntries(
            Object.entries(values).filter(([, v]) => v !== undefined && v !== ''),
          ) as Partial<Slot>;
          
          // word_keyword는 항상 '-'로 설정
          const dtoWithKeyword = { ...dto, word_keyword: '-' };

          if (Object.keys(dto).length === 0) return onClose();
          onSubmit(dtoWithKeyword);
          onClose();
          form.resetFields();
        })
      }
      destroyOnClose
      width={420}
    >
      <p style={{ marginBottom: 16 }}>
        <span style={{ color: '#fa541c' }}>* 체크박스로 선택된 슬롯에만 적용됩니다.</span>
      </p>

      <Form form={form} layout="vertical">
        {/* 아이디 */}
        <Form.Item name="user" label="아이디">
          <Select
            placeholder="(변경 시에만 선택)"
            showSearch
            optionFilterProp="label"
            optionLabelProp="label"
            allowClear
          >
            {sellers.map(s => (
              <Option
                key={s.id}
                value={s.id}
                label={`${s.username} (${s.name})`}
              >
                {s.username} ({s.name})
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="main_keyword" label="메인 키워드">
          <Input placeholder="(변경 시에만 입력)" />
        </Form.Item>

        <Form.Item name="mid_single" label="단일 MID">
          <Input placeholder="(변경 시에만 입력)" />
        </Form.Item>

        <Form.Item name="mid_compare" label="가격비교 MID">
          <Input placeholder="(변경 시에만 입력)" />
        </Form.Item>

        <Form.Item
          name="product_url"
          label="상품 URL"
          rules={[{ type: 'url', message: 'URL 형식이 아닙니다.' }]}
        >
          <Input placeholder="https://..." />
        </Form.Item>

        <Form.Item
          name="compare_url"
          label="가격비교 URL"
          rules={[{ type: 'url', message: 'URL 형식이 아닙니다.' }]}
        >
          <Input placeholder="https://..." />
        </Form.Item>

        <Form.Item name="memo" label="메모">
          <Input.TextArea rows={3} placeholder="(변경 시에만 입력)" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SlotBulkEditModal;
